import {
  keepPreviousData,
  useQuery,
  type UseQueryOptions,
} from '@tanstack/react-query'
import {
  listJetAlerts,
  type ListJetAlertsRequest,
} from 'api/admin/jet/listJetAlerts'
import { jetKeys } from './keys'

type QueryData = Awaited<ReturnType<typeof listJetAlerts>>
type QueryKey = ReturnType<typeof jetKeys.alertsList>

type UseJetAlertsQueryOptions = Partial<
  UseQueryOptions<QueryData, Error, QueryData, QueryKey>
>

// Fetches a single keyset page (the cursor is baked into `params`). Prev/Next is
// driven by the caller swapping the cursor; `keepPreviousData` keeps the current
// page visible while the next one loads instead of flashing empty.
export const useJetAlertsQuery = (
  params: ListJetAlertsRequest,
  options: UseJetAlertsQueryOptions = {}
) => {
  return useQuery<QueryData, Error, QueryData, QueryKey>({
    ...options,
    queryKey: jetKeys.alertsList(params),
    queryFn: () => listJetAlerts(params),
    placeholderData: keepPreviousData,
  })
}
